<template>
  <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
    <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
      <template slot-scope="scope">
        <span>{{ (scope.$index + 1) + (pageIndex - 1) * limit }}</span>
      </template>
    </el-table-column>
    <el-table-column label="商品名称" prop="goodsName" min-width="150" class-name="name-col" />
    <el-table-column label="商品图片" prop="cover" width="100" class-name="image-col">
      <template slot-scope="{row}">
        <el-image :src="row.cover" :preview-src-list="[row.cover]" lazy />
      </template>
    </el-table-column>
    <el-table-column label="商品分类" width="100" align="center">
      <template slot-scope="{row}">
        <div class="flex-tag">
          <el-tag v-if="row.categoryName" effect="plain">{{ row.categoryName }}</el-tag>
          <template v-if="row.section">
            <el-tag v-for="(section, index) in row.sections" :key="index" :type="section|tagType" effect="dark">{{ section | activateZone }}</el-tag>
          </template>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="进价和成本" width="120">
      <template slot-scope="{row}">
        <p><span class="bold">供货价：</span>{{ row.stockPrice | filterPrice }}</p>
        <p><span class="bold">成本价：</span>{{ row.costPrice | filterPrice }}</p>
      </template>
    </el-table-column>
    <template v-if="mall === 'premium'">
      <el-table-column label="零售价" prop="retailPrice" width="80" align="right">
        <template slot-scope="{row}">{{ row.retailPrice | filterPrice }}</template>
      </el-table-column>
      <el-table-column label="惊喜倍数" prop="surprise" width="80" align="center" />
    </template>
    <template v-else-if="mall === 'welfare'">
      <el-table-column label="零售价" prop="retailPrice" width="80" align="right">
        <template slot-scope="{row}">{{ row.retailPrice | filterPrice }}</template>
      </el-table-column>
      <el-table-column label="售价" prop="point" width="120">
        <template slot-scope="{row}">
          <p><span class="bold">现金：</span>{{ row.pointPrice | filterPrice }}</p>
          <p><span class="bold">积分：</span>{{ row.point | filterPrice }}</p>
        </template>
      </el-table-column>
      <el-table-column label="惊喜倍数" prop="surprise" width="80" align="center" />
    </template>
    <template v-else-if="mall === 'point'">
      <el-table-column label="兑换积分" prop="point" width="100" align="right">
        <template slot-scope="{row}">{{ row.point | filterInteger }}</template>
      </el-table-column>
    </template>
    <el-table-column label="库存" prop="quantity" width="80" align="right" />
    <el-table-column label="排序" prop="sortBy" width="80" align="center" />
    <el-table-column label="状态" width="120" align="center">
      <template slot-scope="{row}">
        <div class="flex-switch">
          新品：<el-switch v-model="row.isNew" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row, 'isNew')" />
        </div>
        <div class="flex-switch">
          推荐：<el-switch v-model="row.isHot" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row, 'isHot')" />
        </div>
        <div class="flex-switch">
          上架：<el-switch v-model="row.isOnsale" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row, 'isOnsale')" />
        </div>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="100" fixed="right">
      <template slot-scope="{row}">
        <el-button type="text" @click.native="handleEdit(row.id)">编辑</el-button>
        <el-button type="text" @click.native="handleRemove(row.id)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { updateGoodsStatus } from '@/api/goods'
import { StickyHeader } from '@cell-x/el-table-sticky'

export default {
  name: 'DataTable',
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  emits: ['edit', 'delete'],
  filters: {
    activateZone(index) {
      const zones = ['激活专区一', '激活专区二', '激活专区三']
      return zones[index - 1]
    },
    tagType(index) {
      const tag = ['', 'success', 'info']
      return tag[index - 1]
    }
  },
  props: {
    pageIndex: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    list: {
      type: Array,
      default: () => []
    },
    mall: {
      type: String,
      default: 'premium'
    }
  },
  methods: {
    handleEdit(goodsId) {
      this.$emit('edit', { value: goodsId })
    },
    handleRemove(goodsId) {
      this.$confirm('确定要删除该商品吗？', '温馨提示', { type: 'warning' }).then(() => {
        this.$emit('delete', { value: goodsId })
      }).catch(() => {})
    },
    handleUpdate(item, field) {
      updateGoodsStatus(item).then(response => {
        if (!response) item[field] = !item[field]
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .flex-tag {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .el-tag {
      display: block;
      width: 100%;
      + .el-tag {
        margin-top: 8px;
      }
    }
  }
  .flex-switch {
    display: flex;
    align-items: center;
    justify-content: center;
    + .flex-switch {
      margin-top: 5px;
    }
  }
</style>
